module.exports = __webpack_public_path__ + "img/banner-tc2.aa924114.jpg";